export class DbFile {
  id?: string;
  name: string;
  src?: string;

  // helper
  uploadSrc?: string;
}
